import React from 'react'

import Invitation from 'components/Invitation'

const InvitationPage: React.FC = () => {
  return <Invitation />
}

export default InvitationPage
